import { React, useState, useEffect } from 'react';
import User from '../../../components/Settings/User/User';
import SideBar from '../../../components/SideBar/SideBar';
import CollapseIcon from '../../../assets/images/sidebar_collapse_arrow.svg';
import BannerNotification from 'components/BannerNotification/BannerNotification';

function UserContainer({ show, history }) {
  const [isActive, setActive] = useState("false");

  const handleToggle = () => {
    setActive(!isActive);
  };

  useEffect(() => {
    const userToken = localStorage.getItem('token')
    const userRToken = localStorage.getItem('refreshtoken')
    const userInfo = JSON.parse(localStorage.getItem('user'))
    const name = userInfo?.name
    if (!userToken && !userRToken && !name) {
      return history.push('/')
    }
    // eslint-disable-next-line
  }, [history])

  return (
    <div className='sidebar_main_wrapper'>
      <div className={isActive ? "sidebar" : "sidebar sidebar-collapse"}>
        <button onClick={handleToggle} className={isActive ? 'collapse-icon' : 'collapse-icon rotate-icon'}>
          <img src={CollapseIcon} alt="icon" />
        </button>
        <SideBar />
      </div>
      <div className={isActive ? "right-container" : "right-container right-container-collapse"}>
        <BannerNotification />
        <div className='right-inner-container'>
          <User />
        </div>
      </div>
    </div>
  )
}

export default UserContainer;
